import "./Footer.scss";

import React, { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { graphql, useStaticQuery } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services";

import buttonArrow from "../../images/icons/button-arrow.svg";
import enveloppe from "../../images/icons/enveloppe.svg";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import facebook from "../../images/icons/facebook.svg";
import findReplace from "../../images/icons/find-replace.svg";
import headsetMic from "../../images/icons/headset-mic.svg";
import littleEnveloppe from "../../images/icons/little-enveloppe.svg";
import littlePhone from "../../images/icons/little-phone.svg";
import progiLogo from "../../images/Progy.svg";
import shieldWithCheck from "../../images/icons/shield-checkmark.svg";
import youtube from "../../images/icons/youtube.svg";
import { FeedbackContext } from "../../contexts/feedback/feedbackContext";
import { Input } from "../primitives";
import SiteLocaleSelectionPopupMenu from "../SiteLocale/SiteLocaleSelectionPopupMenu";
import LocalizedLink from "../primitives/LocalizedLink";

export default function Footer(props: { venting: Map<any, any>; footerCms: any }) {
    const { t } = useTranslation("layout");
    const { venting, footerCms } = props;
    const { navigateTranslated, currentLocale, LinkTranslated } = usePageLocalization();

    const data = useStaticQuery(graphql`
        query {
            customerServiceInfo: allProductsJson(
                filter: { code: { eq: "drolet_customer-service" } }
            ) {
                nodes {
                    ...contactUsInformationFragment
                }
            }
            technicalSupportInfo: allProductsJson(
                filter: { code: { eq: "drolet_technical-support" } }
            ) {
                nodes {
                    ...contactUsInformationFragment
                }
            }
            retailerServiceInfo: allProductsJson(
                filter: { code: { eq: "drolet_retailer-service" } }
            ) {
                nodes {
                    ...contactUsInformationFragment
                }
            }
            brochure: allProductsJson(filter: { code: { eq: "drolet_catalogue" } }) {
                nodes {
                    title {
                        fr_CA
                        en_CA
                        en_US
                    }
                    documents {
                        en_CA
                        en_US
                        fr_CA
                        caption {
                            fr_CA
                            en_CA
                            en_US
                        }
                    }
                }
            }
        }
    `);

    return (
        <footer>
            <InfoSection footerCms={footerCms} />
            <InfoLetter footerCms={footerCms} />
            <FooterContent />
        </footer>
    );

    function InfoSection(props: { footerCms: any }) {
        const { currentLocale } = usePageLocalization();
        const { footerCms } = props;

        return (
            <div className="footer-info-container">
                <div className="info">
                    <h3>{footerCms?.attributes?.texte_1?.values[0][currentLocale]}</h3>
                    <div className="line"></div>
                    <div className="content">
                        <div className="group">
                            <div className="content-group">
                                <img src={shieldWithCheck} alt="" className="icon shield" />
                                <LinkTranslated
                                    url={footerCms?.attributes?.links?.values?.[0]?.[currentLocale]}
                                >
                                    {footerCms?.attributes?.bouttons?.values?.[0]?.[currentLocale]}
                                </LinkTranslated>
                            </div>
                        </div>
                        <div className="group">
                            <div className="content-group">
                                <img src={findReplace} alt="" className="icon find" />
                                <LinkTranslated
                                    url={
                                        "/archives/"
                                        /*   footerCms?.attributes?.links
                                            ?.values?.[1]?.[currentLocale] */
                                    }
                                >
                                    {currentLocale === "fr_CA"
                                        ? "Trouver mes pièces de remplacement et manuels"
                                        : "Find my replacement parts and manuals"}
                                    {/*  { FIXME: boutik-data-provicer ne retourne pas tout les elements du array (link, bouttons)

                                        footerCms?.attributes?.bouttons
                                            ?.values?.[1]?.[currentLocale]
                                    } */}
                                </LinkTranslated>
                            </div>
                        </div>
                        <div className="group">
                            <div className="content-group">
                                <img src={headsetMic} alt="" className="icon headset" />
                                <LinkTranslated
                                    url={
                                        "/contact/technical-support/"
                                        /*  footerCms?.attributes?.links
                                            ?.values?.[2]?.[currentLocale] */
                                    }
                                >
                                    {currentLocale === "fr_CA"
                                        ? "Demander l'assistance du service après-vente"
                                        : "Request after-sales service assistance"}
                                    {/*  {
                                        footerCms?.attributes?.bouttons
                                            ?.values?.[2]?.[currentLocale]
                                    } */}
                                </LinkTranslated>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function InfoLetter(props: { footerCms: any }) {
        const { footerCms } = props;
        const [email, setEmail] = useState("");
        const [subscribeLoading, setSubscribeLoading] = useState<boolean>(false);
        const { addAlert } = useContext(FeedbackContext);

        const servicesContext = useContext(ServicesContext);
        const customerService = servicesContext?.magento.customerService;

        const { currentLocale } = usePageLocalization();
        const subscribeEmail = useCallback(async () => {
            setSubscribeLoading(true);
            await customerService.operations
                .subscribeEmailToNewsletter(email)
                .then(() =>
                    addAlert({
                        message: t("toastMessages:subscribe-newsletter-success", { email: email }),
                        status: "success",
                    })
                )
                .catch((error) => addAlert({ message: error, status: "error" }))
                .finally(() => {
                    setSubscribeLoading(false);
                });
        }, [addAlert, email, servicesContext]);

        return (
            <div className="footer-infomail">
                <div className="top">
                    <img className="enveloppe" src={enveloppe} alt=""></img>
                    <div className="enveloppe-text">
                        {footerCms?.attributes?.texte_3?.values[0][currentLocale]}
                        <span className="line"></span>
                    </div>
                </div>
                <div className="top email-input">
                    <Input
                        value={email}
                        placeholder={t("footer.newsletter.placeholder")}
                        onChange={(value: any) => setEmail(value)}
                        onKeyDown={(key: any) => {
                            if (key === "Enter" && !subscribeLoading) subscribeEmail();
                        }}
                    />
                    <img
                        src={buttonArrow}
                        alt=""
                        className={subscribeLoading ? "arrow loading" : "arrow"}
                        onClick={() => {
                            if (!subscribeLoading) subscribeEmail();
                        }}
                    />
                </div>
            </div>
        );
    }

    function FooterContent() {
        const ventingMenuElem = Array.from(venting)[0][1]
            .sort((a: any, b: any) => a.label > b.label)
            .map((single: { label: string; category: string }) => {
                const category = single.category.split("/")[3].toLowerCase().replaceAll(" ", "-");
                return {
                    title: single.label,
                    link: `/venting/${category}/`,
                };
            });

        const carreerLink =
            currentLocale === "fr_CA"
                ? "https://www.sbi-international.com/fr/carrieres/"
                : "https://www.sbi-international.com/en/careers/";

        const customerServiceInfo = data?.customerServiceInfo?.nodes?.[0];
        const technicalSupportInfo = data?.technicalSupportInfo?.nodes?.[0];
        const retailerServiceInfo = data?.retailerServiceInfo?.nodes?.[0];

        return (
            <div className="footer-content-top">
                <div className="footer-content">
                    <div className="footer-pages-list">
                        <div className="footer-row">
                            <div className="title">
                                <MenuTitle title="appliances" />
                            </div>
                            <div className="links">
                                <ul>
                                    <li>
                                        <MenuTitle title="wood-stoves" link="/wood-stoves" />
                                    </li>
                                    <li>
                                        <MenuTitle
                                            title="appliance-pellet-stoves"
                                            link="/pellet-stoves"
                                        />
                                    </li>
                                    <li>
                                        <MenuTitle title="wood-inserts" link="/wood-inserts/" />
                                    </li>
                                    <li>
                                        <MenuTitle title="wood-furnaces" link="/wood-furnaces/" />
                                    </li>
                                    <li>
                                        <MenuTitle title="wood-cook-stoves" link="/cook-stoves/" />
                                    </li>
                                    <li>
                                        <MenuTitle
                                            title="outdoor-fireplaces"
                                            link="/outdoor-fireplaces/"
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="footer-row">
                            <div className="title">
                                <MenuTitle title="ventings" />
                            </div>
                            <div className="links">
                                <ul>
                                    {ventingMenuElem.map((element: any, index: number) => {
                                        return (
                                            <li key={index}>
                                                <MenuTitle
                                                    title={element.title}
                                                    link={element.link}
                                                    isLitteral={true}
                                                />
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className="footer-row">
                            <div className="title more-margin">
                                <MenuTitle
                                    title="accessories"
                                    link={t("url:accessories") as string}
                                />
                            </div>
                            <div className="title more-margin">
                                <MenuTitle title="parts" link="/archives/" />
                            </div>
                            <div className="title more-margin">
                                <MenuTitle title="promotions" link="/promotions/" />
                            </div>
                            <div className="title more-margin">
                                <MenuTitle title="test-reports" link="test-reports/" />
                            </div>
                            <div className="title more-margin">
                                {
                                    <a
                                        className="menu-title"
                                        href={carreerLink}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {t("meta-titles.career")}
                                    </a>
                                }
                            </div>
                            <div className="title more-margin">
                                {
                                    <a
                                        className="menu-title"
                                        href={
                                            "/file/" +
                                            data?.brochure?.nodes[0].documents[0][currentLocale]
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {data.brochure.nodes[0].title[currentLocale]}
                                    </a>
                                }
                            </div>
                        </div>
                        <div className="footer-row">
                            <div className="title">
                                <MenuTitle title="support-service" />
                            </div>
                            <div className="links">
                                <ul>
                                    <li>
                                        <MenuTitle title="manuals" link="/archives/" />
                                    </li>
                                    <li>
                                        <MenuTitle
                                            title="warranty"
                                            link="/warranty/stoves-inserts/"
                                        />
                                    </li>
                                    <li>
                                        <MenuTitle title="where-to-buy" link="/where-to-buy/" />
                                    </li>
                                    <li>
                                        <MenuTitle title="find-retailer" link="/find-retailer/" />
                                    </li>
                                    <li>
                                        <MenuTitle title="contact" link="/contact/" />
                                    </li>
                                    <li>
                                        <MenuTitle title="videos" link="/videos/" />
                                    </li>
                                    <li>
                                        <MenuTitle title="blog" link="/blogArchives/" />
                                    </li>
                                    <li>
                                        <MenuTitle title="about" link="/about/" />
                                    </li>
                                    <li>
                                        <MenuTitle title="gov-incentives" link="/gov-incentives/" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="footer-contact">
                        <ContactInfo
                            title={customerServiceInfo?.title?.[currentLocale]}
                            email={
                                customerServiceInfo?.attributes?.link?.values?.[0]?.[currentLocale]
                            }
                            phoneNumber={
                                customerServiceInfo?.attributes?.texte_1?.values?.[0]?.[
                                    currentLocale
                                ]
                            }
                        />
                        <ContactInfo
                            title={technicalSupportInfo?.title?.[currentLocale]}
                            email={
                                technicalSupportInfo?.attributes?.link?.values?.[0]?.[currentLocale]
                            }
                            phoneNumber={
                                technicalSupportInfo?.attributes?.texte_1?.values?.[0]?.[
                                    currentLocale
                                ]
                            }
                        />
                        <ContactInfo
                            title={retailerServiceInfo?.title?.[currentLocale]}
                            email={
                                retailerServiceInfo?.attributes?.link?.values?.[0]?.[currentLocale]
                            }
                            phoneNumber={
                                retailerServiceInfo?.attributes?.texte_1?.values?.[0]?.[
                                    currentLocale
                                ]
                            }
                        />
                    </div>
                </div>
                <div className="socials">
                    <span className="title" onClick={() => navigateTranslated("/order-status/")}>
                        <MenuTitle title="socials-title" />
                    </span>
                    <span className="separator"></span>
                    <a href="https://www.facebook.com/Drolet.ca" target="_blank" rel="noreferrer">
                        <img src={facebook} alt="" className="icon" />
                    </a>
                    <a href="https://www.instagram.com/drolet.ca" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faInstagram} className="icon" />
                    </a>
                    <a
                        href="https://www.youtube.com/channel/UC6xtCC045b-jnZ-DkUBqkmQ"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={youtube} alt="" className="icon" />
                    </a>
                    <span className="separator no-mobile"></span>
                    <SiteLocaleSelectionPopupMenu showCurrency={true} />
                </div>
                <div className="policies">
                    <div className="link">
                        <MenuTitle title="return-policy" link="/return-policy/" />
                    </div>
                    <span className="separator"></span>
                    <div className="link">
                        <MenuTitle title="shipping-policy" link="/shipping-policy/" />
                    </div>
                    <span className="separator"></span>
                    <div className="link">
                        <MenuTitle title="privacy-policy" link="/privacy-policy/" />
                    </div>
                    <span className="separator"></span>
                    <div className="link">
                        <MenuTitle title="terms-conditions" link="/terms-and-conditions/" />
                    </div>
                </div>
                <div className="developed-by">
                    <a target="__blank" href="https://www.progymedia.com">
                        {t("layout:footer.developed-by")} <img src={progiLogo} alt="Progymedia" />
                    </a>
                </div>
                <div className="copyright">
                    &#169;
                    {t("footer.copyright", {
                        year: new Date().getFullYear(),
                    })}
                </div>
            </div>
        );
    }

    function ContactInfo(props: { title: string; email: string; phoneNumber: string }) {
        const { email, phoneNumber, title } = props;
        return (
            <div className="contact-info">
                <div className="contact-info-wrapper">
                    <span className="title">{title?.toUpperCase()}</span>
                    <div className="email">
                        <img src={littleEnveloppe} alt="" className="icon"></img>
                        <a href={`mailto:${email}`}>{email}</a>
                    </div>
                    <div className="phone">
                        <img src={littlePhone} alt="" className="icon"></img>

                        <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                    </div>
                </div>
            </div>
        );
    }

    function MenuTitle(props: { title: string; link?: string; isLitteral?: boolean }) {
        return props.link ? (
            <LocalizedLink
                className="menu-title"
                to={props.link}
                label={props.isLitteral ? props.title : (t(`meta-titles.${props.title}`) as string)}
            />
        ) : (
            <span className="menu-title">{t(`meta-titles.${props.title}`)}</span>
        );
    }
}
